import { render, staticRenderFns } from "./QuestionMap.vue?vue&type=template&id=492bf31f&"
import script from "./QuestionMap.vue?vue&type=script&lang=js&"
export * from "./QuestionMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports